import { createRatesService } from './rate.service';

const ENDPOINT = '/api/corporation_tax_rates';
const EnhancementRateService = createRatesService(ENDPOINT, 'corporation_tax_rate');

export default EnhancementRateService;